<template>
  <UiContainer tag="section">
    <ul class="scrollbar-hidden flex gap-2 overflow-scroll">
      <li class="flex shrink-0">
        <UiButtonLink
          tag="a"
          href="https://gazprombonus.ru/catalog?promotion=2659&productType=PRODUCT_TYPE_OPTION&productId=937&utm_source=partner&utm_medium=partner&utm_campaign=intickets&utm_content=website&utm_term=logo"
        >
          <GazpromBonusLogoBlue height="42" width="120" />
        </UiButtonLink>
      </li>
      <li v-for="category in categoriesNav" :key="category.id">
        <UiButton
          :tag="AppRouterLink"
          :to="{ name: 'CategoryItemView', params: { id: category.id } }"
          severity="tertiary"
          class="flex items-center gap-1 px-5 py-2"
        >
          <UiIcon :name="iconsMap[category.name.toLowerCase()]" class="size-4 text-icon-primary" />
          {{ category.name }}
        </UiButton>
      </li>
    </ul>
  </UiContainer>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useConfiguration } from '@/5_entities/Configuration'
import { AppRouterLink, UiButton, UiButtonLink, UiContainer, UiIcon, GazpromBonusLogoBlue } from '@/6_shared/ui'

const { categoriesNav } = storeToRefs(useConfiguration())

const iconsMap: Record<string, string> = {
  шоу: 'category-shou',
  кино: 'category-kino',
  встречи: 'category-vstrechi',
  экскурсия: 'category-ekskursia',
  спорт: 'category-sport',
  обучение: 'category-obuchenie',
  концерт: 'category-koncert',
  театр: 'category-teatr',
  выставка: 'category-vistavka',
  фестиваль: 'category-festival'
}
</script>
